import { Group } from '@ekhodealer/ekho-common/rev';

import { StatBox } from '@common/components/StatBox';
import { formatCurrency, formatNumber } from '@common/lib/currency';
import { PLACEHOLDER } from '@common/lib/strings';

import { useGetOrderStats } from '../api/useGetOrderStats';

export function OrderStats() {
	const { data: stats, isLoading } = useGetOrderStats();

	// Use placeholder if loading
	const placeholder = isLoading ? PLACEHOLDER : undefined;

	return (
		<Group itemsSpacing='16' noWrap itemsAlignX='stretch'>
			<StatBox
				title='Total order value'
				detail={formatCurrency(stats?.totalOrderValue, placeholder, false)}
			/>
			<StatBox
				title='Avg order value'
				detail={formatCurrency(stats?.averageOrderValue, placeholder, false)}
			/>
			<StatBox
				title='Total active orders'
				detail={formatNumber(stats?.totalActiveOrders, placeholder)}
			/>
			<StatBox
				title='Pending tasks'
				detail={formatNumber(stats?.totalPendingTasks, placeholder)}
			/>
		</Group>
	);
}
